import { render, staticRenderFns } from "./countBadge.vue?vue&type=template&id=793f9107&"
import script from "./countBadge.vue?vue&type=script&lang=js&"
export * from "./countBadge.vue?vue&type=script&lang=js&"
import style0 from "./countBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports